import types from "../types";

const initialState = {
  adsCampaigns: {},
  adsCampaignsIDsByAgency: [],
  schemas: {},
  isLoading: true,
  statusOverrides: {},
};

export const adsCampaignsReducer = (state = initialState, action) => {
  let currentAdsCampaigns;
  switch (action.type) {
    case types.GET_ADS_CAMPAIGNS_FINISH:
      return {
        ...state,
        adsCampaigns: action.payload,
        isLoading: false,
      };
    case types.GET_NEXT_ADS_CAMPAIGNS__FINISH:
      return {
        ...state,
        adsCampaigns: {
          ...state.adsCampaigns,
          ...action.payload,
        },
        isLoading: false,
      };
    case types.SAVE_ADS_CAMPAIGN_FINISH:
      return {
        ...state,
        adsCampaigns: {
          ...state.adsCampaigns,
          [action.payload.key]: {
            ...state.adsCampaigns[action.payload.key],
            ...action.payload.data,
          },
        },
      };
    case types.DELETE_ADS_CAMPAIGN_FINISH:
      currentAdsCampaigns = { ...state.adsCampaigns };
      delete currentAdsCampaigns[action.payload.campaignID];
      return {
        ...state,
        adsCampaigns: currentAdsCampaigns,
      };
    case types.GET_ADS_CAMPAIGNS_IDS_BY_AGENCY:
      return {
        ...state,
        adsCampaignsIDsByAgency: action.payload,
      };
    case types.GET_ADS_CAMPAIGNS_SCHEMAS:
      return {
        ...state,
        schemas: action.payload,
      };
    case types.GET_BASIC_DATA_ADS_CAMPAIGN:
      return {
        ...state,
        adsCampaigns: {
          ...state.adsCampaigns,
          [action.payload.key]: {
            ...state.adsCampaigns[action.payload.key],
            ...action.payload.data,
          },
        },
      };

    // Publishing campaign alerts moved to alertsReducer for centralized notification management

    case types.CLEAN_ADS_CAMPAIGNS:
      return initialState;
    case types.GLOBAL_RESET_STATE:
      return initialState;
    case types.GLOBAL_RESET_ADVERTISER_DATA:
      return initialState;
    case types.SET_ADS_CAMPAIGN_STATUS_OVERRIDE:
      return {
        ...state,
        statusOverrides: {
          ...state.statusOverrides,
          [action.payload.campaignID]: action.payload.status,
        },
      };
    case types.REMOVE_ADS_CAMPAIGN_STATUS_OVERRIDES: {
      if (!Array.isArray(action.payload) || action.payload.length === 0) {
        return state;
      }
      const statusOverrides = { ...state.statusOverrides };
      action.payload.forEach((campaignID) => {
        delete statusOverrides[campaignID];
      });
      return {
        ...state,
        statusOverrides,
      };
    }

    default:
      return state;
  }
};
